import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  /** A single primary action, when there is an obvious next step. */
  readonly action?: ReactNode;
  readonly className?: string;
}

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cx('flex flex-col items-center gap-2 px-6 py-12 text-center', className)}>
      <p className="text-sm font-semibold text-ink">{title}</p>
      {description !== undefined && <p className="max-w-sm fs-13 text-muted">{description}</p>}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  );
}
